import {useEffect} from 'react';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {SkipButton} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/components/SkipButton';
import {Step} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/Step';
import {Header} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/components/Header/Header';
import {useSuccessPageRokt} from './useSuccessPageRokt';

import './SuccessRokt.sass';

type SuccessRoktProps = {
  onNext?: () => void;
  onClose?: () => void;
  onPlacementClosed: () => void;
  showSkipButton?: boolean;
  onUnmountAnchorTo?: string;
};

export const SuccessRokt = ({
  onNext,
  onClose,
  onPlacementClosed,
  showSkipButton,
  onUnmountAnchorTo,
}: SuccessRoktProps) => {
  const {subscribe} = useSuccessPageRokt();
  const isLargishAndUp = useIsLargishAndUp();

  useEffect(() => {
    subscribe('PLACEMENT_CLOSED', onPlacementClosed);
  }, [onPlacementClosed, subscribe]);

  useEffect(
    () => () => {
      if (onUnmountAnchorTo) {
        const anchorElement = document.querySelector(onUnmountAnchorTo);
        if (anchorElement) {
          anchorElement?.scrollIntoView({behavior: 'smooth'});
        }
      }
    },
    [onUnmountAnchorTo]
  );

  return (
    <Step
      header={
        <Header
          title="Your RSVP is confirmed"
          showSkipButton={isLargishAndUp && showSkipButton}
          onSkip={onNext}
          onClose={onClose}
          titleLeftAligned
        />
      }
      description="From Evite: optional offers and worthy causes"
      footer={
        !isLargishAndUp &&
        showSkipButton &&
        onNext && (
          <div className="success-rokt__footer__wrapper">
            <SkipButton onClick={onNext} />
          </div>
        )
      }
    >
      <div id="rokt_rsvpcontainer" />
    </Step>
  );
};
